import { StepsNavigation, StepsFooter, type NavItem } from "../common";
import Header from "../Header";
import React from "react";

const BASE = "/promotioniq";

const navItems: NavItem[] = [
  {
    path: BASE,
    label: "Command",
    children: [
      { path: `${BASE}/retailer-investment`, label: "Retailers" },
      { path: `${BASE}/retailer-promotion-truth`, label: "Truth" },
    ]
  },
  { path: `${BASE}/baseline-diagnostics`, label: "Baseline" },
  { path: `${BASE}/promotion-portfolio`, label: "Portfolio" },
  {
    path: `${BASE}/promotion-builder`,
    label: "Builder",
    children: [
      { path: `${BASE}/shopper-influence`, label: "Influence" },
      { path: `${BASE}/impact-panel`, label: "Impact" },
    ]
  },
  { path: `${BASE}/scenarios`, label: "Scenarios" },
  {
    path: `${BASE}/monitoring`,
    label: "Monitor",
    children: [
      { path: `${BASE}/learnings`, label: "Learn" },
    ]
  },
  { path: `${BASE}/negotiation`, label: "Negotiate" },
  { path: `${BASE}/summary`, label: "Summary" },
];

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#0c1017' }}>
      {/* Fixed Header - with compact styling */}
      <Header 
        token={undefined}
        isMarketplacePage={undefined}
        notificationsCount={undefined}
        refreshNotifications={undefined}
        setIndustry={undefined}
        setCompany={undefined}
        leftNode={undefined}
        productLabel="Promotion IQ" 
        fixed={true}
      />

      {/* Fixed Steps Navigation - below header */}
      <StepsNavigation
        navItems={navItems}
        basePath={BASE}
      />

      {/* Main content with padding for fixed header and footer */}
      <main className="flex-1 p-6 animate-fade-in pt-[200px] pb-[80px]" style={{ backgroundColor: '#0c1017' }}>
        {children}
      </main>

      {/* Fixed Footer - navigation logic is now inside StepsFooter */}
      <StepsFooter
        navItems={navItems}
        basePath={BASE}
      />
    </div>
  );
}
